<template>
  <div class="explain">
    <h1>帳號聲明</h1>
    <div class="content" v-html="association.explain"></div>
  </div>
</template>

<script>
export default {
    data() {
        return {
          association: this.$store.getters.association,
        }
    },
    mounted: function(){
    },
};

</script>

<style scoped>
  .explain {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .explain .menus {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 1px 1px 1px #e9e7e7;
  }

  .explain .menus > .menu {
    height: 40px;
    line-height: 40px;
    margin: 0 8px;
    padding: 0 12px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    border-bottom: 1px solid #e8e8e8;
  }

  .explain .menus > .menu.current {
    color: #f00;
  }

  .explain .menus > .menu:last-child {
    border-bottom: 0;
  }

  .explain > .menus-wrapper {
    margin: 0 10px;
  }

  .explain > .content {
    flex: 1;
    background-color: #fff;
    padding: 12px;
    margin-right: 10px;
    box-sizing: border-box;
    border: 1px solid #e8e8e8;
    box-shadow: 1px 1px 1px #e9e7e7;
    font-size: 17px;
    line-height: 28px;
    border-radius: 8px;
  }

  .explain > .content::first-letter {
    margin-left: 40px;
    margin-top: 12px;
  }

  .explain h1 {
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #1f1f1f;
  }

  @media only screen and (max-width: 1050px) {
    .explain {
      width: 100%;
    }

    .explain > .content {
      margin: 10px;
    }
  }
</style>
